import { render, staticRenderFns } from "./ModalOnboarding.vue?vue&type=template&id=0365b416&scoped=true&"
import script from "./ModalOnboarding.vue?vue&type=script&lang=js&"
export * from "./ModalOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnboarding.vue?vue&type=style&index=0&id=0365b416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365b416",
  null
  
)

export default component.exports